/**
 * Batched low lift test 5, test 2:
 * PRD: https:www.notion.so/faire/Low-lift-testing-Batch-5-
 * 528305362d4d4455a8d8ad0edaf65767?pvs=4#f108e0539c2e4242b4b7d5e43cbc7468
 */
export const BATCH_5_PRODUCT_SIGN_UP_MODAL_NEW_COPY_102124 = 'BATCH_5_PRODUCT_SIGN_UP_MODAL_NEW_COPY_102124';
